module.exports = __webpack_public_path__ + "static/img/9.93cf15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/9.png
// module id = ORpc
// module chunks = 35